export default "__VITE_ASSET__a38cbd0d__"